import { render, staticRenderFns } from "./Correlation.vue?vue&type=template&id=19126e12&scoped=true"
import script from "./Correlation.vue?vue&type=script&lang=js"
export * from "./Correlation.vue?vue&type=script&lang=js"
import style0 from "./Correlation.vue?vue&type=style&index=0&id=19126e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19126e12",
  null
  
)

export default component.exports